import React from 'react'
import "./Aboutus_banner.css";

export default function Aboutus_banner() {
    return (
        <>
            <section className="Banner-holder">
                <div className="Home-banner">
                    <div className="Banner">
                        <div className="banner-image-holder">
                            <img
                                className="banner-image"
                                src={
                                    process.env.PUBLIC_URL +
                                    "/Assets/Images/about_us/banner/aboutus_banner.png"
                                }
                                alt="banner-image"
                            />
                        </div>
                        <div className="banner-text-holder">
                            <h3>
                                {" "}
                                <span>About Us</span>
                                <br /> Your Partner in Growth{" "}
                            </h3>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
